<div class="tracks-block">
  <div class="tracks-block__wrapper">
    @if (isTracksPage) {
      <bmcore-find-tracks
        [beatmakerId]="beatmakerId"
        [styleId]="styleId"
        [moodId]="moodId"
        [currentSortById]="currentSortById"
        [searchTrack]="searchTrack"
        [searchTagTitle]="searchTagTitle"
        [searchBeatmakerTitle]="searchBeatmakerTitle"
        [isBeatmakerPage]="isBeatmakerPage"
        [isFreeBeatsPage]="isFreeBeatsPage"
        [showSearchFields]="showSearchFields"
        [showCatalogFilters]="showCatalogFilters"
        [selectedTags]="selectedTags"
        [tagsMode]="tagsMode"
        [instrumentIds]="instrumentIds"
        [instrumentsMode]="instrumentsMode"
        [keyId]="keyId"
        [trackTypeId]="trackTypeId"
        [bpmFrom]="bpmFrom"
        [bpmTo]="bpmTo"
        [priceFrom]="priceFrom"
        [priceTo]="priceTo"
        [hasActiveFilters]="hasActiveFilters"
        (filterTracksEvent)="filterTracks($event)"
      >
      </bmcore-find-tracks>
    }

    <!-- Подгрузка треков по скроллу (IntersectionObserver, см. компонент) -->
    <div class="tracks-block__tracks-list">
      @if (isTracksPage) {
        <div>
          @for (track of tracks; track track.id) {
            <bmcore-track-item
              [track]="track"
              [isShowFavBtn]="checkToShowFavBtn()"
              (setPlaylistEvent)="setPlaylist()"
              [appType]="appType"
              [ordinalNumber]="track.ordinalNumber"
              [showVerificationIcon]="showVerificationIcon"
            >
            </bmcore-track-item>
          }
        </div>
        <!-- Маркер конца списка: когда он попадает во вьюпорт — грузим следующую порцию -->
        <div #loadMoreSentinel class="tracks-block__sentinel" aria-hidden="true"></div>
      } @else {
        @for (track of tracks; track track.id) {
          <bmcore-track-item
            [track]="track"
            [isShowFavBtn]="checkToShowFavBtn()"
            (setPlaylistEvent)="setPlaylist()"
            [appType]="appType"
            [ordinalNumber]="track.ordinalNumber"
            [showVerificationIcon]="showVerificationIcon"
          >
          </bmcore-track-item>
        }
      }

      <!-- Track list без подгрузки по скроллу. Отображается только на главной странице -->
    </div>

    <!-- Loader -->
    <div class="tracks-block__spinner">
      @if (isLoader) {
        <bmcore-loader></bmcore-loader>
      }
    </div>

    <!-- No matching results -->
    @if (tracksNotFound) {
      <div class="tracks-block__not-found">
        <bmcore-no-matching-search></bmcore-no-matching-search>
      </div>
    }

    <!-- Button "Показать весь треклист" отображается только на главной странице  -->
    @if (!isTracksPage && hasMoreTracksToShow) {
      <div class="tracks-block__btn">
        <bmcore-button
          themeBtnClass="theme-btn__beatsBlock"
          title="{{ lg.button.showMore }}"
          routerPath="catalog"
          [styleName]="'center'"
        >
        </bmcore-button>
      </div>
    }
  </div>
</div>
